export default "__VITE_ASSET__CQWVo_Ov__"